<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3"><strong><a id="page_xvii">ABBREVIATIONS</a></strong></h1><a id="page_xvii">
<table>
<tbody>
<tr>
<td class="col1"><p class="t-left"><em>BSac</em></p></td>
<td class="col2"><p class="t-left"><em>Bibliotheca Sacra</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CBQ</em></p></td>
<td class="col2"><p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CO</em></p></td>
<td class="col2"><p class="t-left"><em>Calvini Opera — Corpus Reformatorum</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Comm.</em></p></td>
<td class="col2"><p class="t-left">Calvin’s <em>Commentaries</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CR</em></p></td>
<td class="col2"><p class="t-left"><em>Corpus Reformatorum</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CTJ</em></p></td>
<td class="col2"><p class="t-left"><em>Calvin Theological Journal</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CTM</em></p></td>
<td class="col2"><p class="t-left"><em>Concordia Theological Monthly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CurTM</em></p></td>
<td class="col2"><p class="t-left"><em>Currents in Theology and Mission</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EvQ</em></p></td>
<td class="col2"><p class="t-left"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ExpT</em></p></td>
<td class="col2"><p class="t-left"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>GTJ</em></p></td>
<td class="col2"><p class="t-left"><em>Grace Theological Journal</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>HorBT</em></p></td>
<td class="col2"><p class="t-left"><em>Horizons of Biblical Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Int</em></p></td>
<td class="col2"><p class="t-left"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ISBE</em></p></td>
<td class="col2"><p class="t-left"><em>International Standard Bible Encyclopedia</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JETS</em></p></td>
<td class="col2"><p class="t-left"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JSOT</em></p></td>
<td class="col2"><p class="t-left"><em>Journal for the Study of the Old Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LuthQ</em></p></td>
<td class="col2"><p class="t-left"><em>Lutheran Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LW</em></p></td>
<td class="col2"><p class="t-left"><em>Luther’s Works —</em> American Edition</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NGTT</em></p></td>
<td class="col2"><p class="t-left"><em>Nederduitse Gereformeerde Teologiese Tydskrif</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NTS</em></p></td>
<td class="col2"><p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>PG</em></p></td>
<td class="col2"><p class="t-left"><em>Patrologia Graeca</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>PL</em></p></td>
<td class="col2"><p class="t-left"><em>Patrologia Latina</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RevExp</em></p></td>
<td class="col2"><p class="t-left"><em>Review and Expositor</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SJT</em></p></td>
<td class="col2"><p class="t-left"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TDNT</em></p></td>
<td class="col2"><p class="t-left"><em>Theological Dictionary of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Th</em></p></td>
<td class="col2"><p class="t-left"><em>Theology</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TynBul</em></p></td>
<td class="col2"><p class="t-left"><em>Tyndale Bulletin</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>WA</em></p></td>
<td class="col2"><p class="t-left"><em>Weimarer Ausgabe,</em> Luther’s <em>Werke</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>WTJ</em></p></td>
<td class="col2"><p class="t-left"><em>Westminster Theological Journal</em><a id="page_xviii"></a></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?505a8010